// extracted by mini-css-extract-plugin
export default {"root":"TermsOfServicePage_root__gLfJA"};